export default __webpack_public_path__ + "static/media/7minfitness@2x.5c9babf6.jpg";